export const helpFr = {
  open: 'Ouvrir l’aide',
  title: 'Aide',
  search: 'Rechercher dans l’aide',
  noResults: 'Aucun article correspondant.',
  loading: 'Chargement de l’aide…',
  error: 'Impossible de charger l’aide.',
  retry: 'Réessayer',
  fallback: 'Cet article n’est pas encore disponible dans votre langue.',
  allTopics: 'Tous les sujets',
  related: 'Sujets associés',
  empty: 'Aucun article d’aide n’est disponible pour votre rôle. Vous pouvez recharger le contenu.',
  translationStatus:
    '{{current}}/{{total}} articles à jour · {{locales}} langues · {{fallback}} replis · {{stale}} obsolètes',
  categories: {
    general: 'Général',
    accounting: 'Comptabilité',
    documents: 'Documents',
    finance: 'Finance',
    'getting-started': 'Premiers pas',
    manufacturing: 'Production',
    marketing: 'Marketing',
    partners: 'Partenaires',
    plm: 'Développement produit',
    portal: 'Portail client',
    products: 'Produits',
    questionnaires: 'Questionnaires',
    sales: 'Ventes',
    security: 'Sécurité',
    settings: 'Paramètres',
  },
} as const;
